// ============================================================================
// "PLANO DE TREINO COM IA" — duplicado em 16/09/2026 direto de
// fitclutch-mobile/src/config/aiPlanAdvisor.js, sem alteração de lógica.
// Lê as respostas reais do quiz e transforma em configurações de plano de
// verdade (mesmo motor do app mobile) — usado pra montar o "Dia 1" de
// exemplo mostrado antes do paywall.
// ============================================================================

import { MUSCLE_GROUP_KEYS } from './exercisesConfig.js';
import { DURATION_PRESETS_MIN } from './quickWorkoutGenerator.js';
import { DAYS_PER_WEEK_OPTIONS } from './planGenerator.js';

const EXPERIENCE_TO_LEVEL = {
  iniciante: 'beginner',
  intermediario: 'intermediate',
  avancado: 'advanced',
  especialista: 'expert',
};

const GOAL_TO_PLAN_GOAL = {
  condicionamento: 'condicionamento',
  forca: 'forca',
  emagrecer: 'emagrecimento',
  hipertrofia: 'hipertrofia',
};

const LOCATION_TO_PLACE = {
  academia_grande: 'large',
  academia_pequena: 'small',
  academia_casa: 'home',
  peso_corporal: 'bodyweight',
};

const INJURY_AREA_TO_KEY = {
  ombros: 'shoulders',
  costas: 'back',
  joelhos: 'legs',
};

const FOCUS_AREA_TO_GROUPS = {
  ombros: ['shoulders'],
  bracos: ['biceps', 'triceps'],
  peito: ['chest'],
  abdomen: ['abs'],
  costas: ['back'],
  gluteos: ['glutes'],
  pernas: ['legs'],
};

const DURATION_LABEL_TO_MINUTES = {
  rapido: 20,
  curto: 30,
  medio: 50,
  longo: 70,
};

function clampDaysPerWeek(rawValue) {
  const n = Number(rawValue);
  if (!Number.isFinite(n)) return 3;
  return DAYS_PER_WEEK_OPTIONS.reduce((closest, opt) => (Math.abs(opt - n) < Math.abs(closest - n) ? opt : closest), DAYS_PER_WEEK_OPTIONS[0]);
}

function closestDuration(minutes) {
  return DURATION_PRESETS_MIN.reduce((closest, opt) => (Math.abs(opt - minutes) < Math.abs(closest - minutes) ? opt : closest), DURATION_PRESETS_MIN[0]);
}

function inferSplitKey(daysPerWeek, focusGroups) {
  if (focusGroups && focusGroups.length) return 'muscleGroup';
  if (daysPerWeek <= 3) return 'fullBody';
  if (daysPerWeek === 4) return 'upperLower';
  return 'pushPullLegs';
}

export function inferPlanSettingsFromAnswers(answers) {
  if (!answers || typeof answers !== 'object') return null;

  const levelKey = EXPERIENCE_TO_LEVEL[answers.experience] ?? 'intermediate';
  const goalKey = GOAL_TO_PLAN_GOAL[answers.goal] ?? 'hipertrofia';
  const placeKey = LOCATION_TO_PLACE[answers.location] ?? 'large';
  const daysPerWeek = clampDaysPerWeek(answers.days_per_week);

  const rawInjuries = Array.isArray(answers.injuries) ? answers.injuries : [];
  const injuries = rawInjuries.map((a) => INJURY_AREA_TO_KEY[a]).filter(Boolean);

  const focusGroups = FOCUS_AREA_TO_GROUPS[answers.focus_area] ?? [];
  const splitKey = inferSplitKey(daysPerWeek, focusGroups);
  const muscleFocus = splitKey === 'muscleGroup' ? focusGroups.filter((g) => MUSCLE_GROUP_KEYS.includes(g)) : [];

  const durationMinutes = closestDuration(DURATION_LABEL_TO_MINUTES[answers.workout_duration] ?? 40);

  return {
    settings: {
      placeKey,
      customEquipment: [],
      goalKey,
      levelKey,
      durationMinutes,
      daysPerWeek,
      splitKey,
      muscleFocus,
      injuries,
      autoFillWeight: true,
      restSecondsChoice: null,
      variability: 'media',
    },
  };
}
